export default "__VITE_ASSET__DmPoUuI5__"